import { siteConfig } from "@/config/site";
import { PrimaryCta, Section, SecondaryCta } from "./primitives";

export function HomeFinalCtaV2() {
  const city = siteConfig.contact.address.city;

  return (
    <Section labelledBy="final-cta-heading">
      <div className="container-page py-20 md:py-32">
        <div
          className="relative overflow-hidden rounded-[2.5rem] border border-border p-10 text-center md:p-20"
          style={{ background: "var(--gradient-hero), var(--color-surface)" }}
        >
          {/* Ambient visual */}
          <div
            aria-hidden
            className="ambient-blob -left-20 -top-20 h-96 w-96 opacity-40"
            style={{ background: "oklch(0.58 0.228 27 / 0.15)" }}
          />
          <div
            aria-hidden
            className="ambient-blob -right-20 -bottom-20 h-96 w-96 opacity-40"
            style={{ background: "oklch(0.58 0.228 27 / 0.15)" }}
          />

          <div className="relative z-10 mx-auto max-w-3xl">
            <p className="inline-flex items-center gap-2 text-[0.7rem] font-medium uppercase tracking-[0.22em] text-primary">
              Austin search growth engine
            </p>
            <h2
              id="final-cta-heading"
              className="mt-6 text-balance font-display text-4xl leading-[1.02] sm:text-5xl lg:text-6xl"
            >
              Ready to be the next {city} case study?
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg">
              Free 30-minute strategy call with our {city} team. We'll audit your
              current footprint across Google and AI Overviews, then surface the
              three highest-leverage growth points for your market.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <PrimaryCta className="px-8 py-4 text-base" />
              <SecondaryCta
                className="px-8 py-4 text-base"
                label="Read Case Studies"
              />
            </div>
            <p className="mt-6 text-xs text-muted-foreground">
              No obligation. No generic pitch decks. Just engineering-first strategy.
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
}
